import React from 'react';
import PropTypes from 'prop-types';
import Button from 'modules/common/Button';

function ErrorMessage({ error, setError }) {
  const handleDismiss = () => {
    setError(null);
  };
  if (!error) return null;
  return (
    <div className="fixed inset-0 z-40 flex">
      <div className="m-auto relative z-10 bg-gray-50 w-full max-w-xs rounded-lg">
        <div className="p-5 space-y-3">
          <div className="text-center">
            {error?.message || 'An error occured!'}
          </div>
          <div className="flex justify-center">
            <Button onClick={handleDismiss}>Ok</Button>
          </div>
        </div>
      </div>
      <div className="absolute h-full w-full bg-black bg-opacity-25 backdrop-blur-sm" />
    </div>
  );
}

ErrorMessage.defaultProps = {
  error: null,
};

ErrorMessage.propTypes = {
  error: PropTypes.instanceOf(Object),
  setError: PropTypes.func.isRequired,
};

export default ErrorMessage;
